(function () {
  'use strict';
  if (window.textualProductInfoLoaded) return;
  window.textualProductInfoLoaded = true;

  function update(root, variant) {
    var options = variant && variant.options;
    var index = Number(root.dataset.productInfoOptionIndex);
    var value = index < 0 ? root.dataset.productInfoFallbackStyle : options && options[index];
    var normalized = typeof value === 'string' ? value.trim().toLowerCase() : '';
    var entries = Array.from(root.querySelectorAll('[data-product-info-entry]'));
    var match = entries.find(function (entry) {
      return entry.dataset.productInfoStyle.trim().toLowerCase() === normalized;
    });
    var hasContent = Boolean(match);

    root.querySelectorAll('[data-product-info-content]').forEach(function (content) {
      content.replaceChildren();
      if (match) content.appendChild(match.content.cloneNode(true));
    });

    var link = root.querySelector('[data-product-info-link]');
    var tab = root.querySelector('[data-product-info-tab]');
    var mobile = root.querySelector('[data-product-info-mobile]');
    if (!hasContent && link && link.classList.contains('product-tabs__tab-link--active')) {
      var fallback = Array.from(root.querySelectorAll('.js-product-tab')).find(function (candidate) {
        return candidate !== link && !candidate.closest('[hidden]');
      });
      if (fallback) fallback.click();
      else {
        link.classList.remove('product-tabs__tab-link--active');
        tab.classList.add('product-tabs__tab-content--hidden');
      }
    }
    root.querySelectorAll('[data-product-info-item]').forEach(function (item) {
      item.hidden = !hasContent;
    });
    if (mobile && !hasContent) {
      mobile.classList.remove('product-mobile-tabs__tab--active');
      mobile.querySelector('.js-product-mobile-tab-body').style.display = 'none';
    }
  }

  function initialize(scope) {
    scope.querySelectorAll('[data-product-info-root]').forEach(function (root) {
      if (root.dataset.productInfoInitialized) return;
      root.dataset.productInfoInitialized = 'true';
      var data = root.querySelector('[data-product-info-variants]');
      var variants = JSON.parse(data.textContent);
      root.productInfoVariants = variants;
      update(root, variants.find(function (variant) {
        return String(variant.id) === root.dataset.productInfoInitialVariant;
      }));
    });
  }

  document.addEventListener('productVariantChange', function (event) {
    if (!event.detail || event.detail.isQuickView) return;
    document.querySelectorAll('[data-product-info-root]').forEach(function (root) {
      var variants = root.productInfoVariants || [];
      var variant = variants.find(function (item) { return String(item.id) === String(event.detail.id); });
      if (variant) update(root, variant);
    });
  });
  // A style can change while the chosen size is unavailable for that style.
  // Show its garment details even when there is no complete matching variant.
  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input.matches('[data-single-option-selector]')) return;
    var section = input.closest('[data-section-type]');
    if (!section || ['product', 'product-sticky-bar-desktop', 'product-sticky-bar-mobile'].indexOf(section.dataset.sectionType) === -1) return;
    document.querySelectorAll('[data-product-info-root]').forEach(function (root) {
      var index = Number(root.dataset.productInfoOptionIndex);
      if (input.dataset.index !== 'option' + (index + 1)) return;
      if (section.dataset.sectionType === 'product' && !section.contains(root)) return;
      var options = [];
      options[index] = input.value;
      update(root, { options: options });
    });
  });
  document.addEventListener('shopify:section:load', function (event) { initialize(event.target); });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initialize(document); });
  } else initialize(document);
})();
